import { getAllEnumValues } from '../../../common/utils';

export enum UserViewViewMode {
  DETAILS = 'details',
  FUNCTIONS = 'functions',
  GROUPS = 'groups',
  // What the organisation has and its requests for more, behind USE_SELF_SERVE_ACCESS.
  ACCESS = 'access',
}

export const allUserViewViewModes = getAllEnumValues(UserViewViewMode, 'string');

export interface UserViewRouteParams {
  username: string;
  viewMode: UserViewViewMode | undefined;
}
